import { handleLink, LinkOptions } from "@openreply/hobi-router";
import type { Router as RouterInterface } from "@openreply/pattern-library";

import { logger } from "./logger";

export class Router implements RouterInterface {
  getIdFromPath(): string {
    const pathOrQueryParam = window.location.pathname;
    const pathParts = pathOrQueryParam.split("/").filter(Boolean);

    if (pathParts.length === 0) {
      logger.logError(
        "[Content Router] Could not get id from current path",
        pathOrQueryParam
      );
      this.redirectToErrorPage();
    }

    const result = pathParts[pathParts.length - 1];

    logger.logInfo("[Content Router] Found page id", result);
    return result;
  }

  redirectTo(url: string) {
    logger.logInfo("[RedirectTo] Redirecting to url", url);
    window.location.replace(url);
  }

  redirectToErrorPage() {
    this.redirectTo(window.location.origin + "/404");
  }

  handleLink(ref: string, event?: unknown): void {
    handleLink(ref, event as LinkOptions);
  }
}

export const router = new Router();
